import { AnimatePresence, motion } from "framer-motion";

const fadeTypes = (style1, style2) => ({
  fade: {
    initial: { opacity: 0, y: 0, },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 0 },
    transition: { duration: 0.3, ease: "easeOut" }
  },
  pop: {
    initial: { opacity: 0, scale: 1.2 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.8 },
    transition: { duration: 0.3, ease: "easeOut" }
  },
  slide: {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
    transition: { duration: 0.3, ease: "easeOut" }
  },
  rotate: {
    initial: { opacity: 0, rotate: -90, scale: 0.8 },
    animate: { opacity: 1, rotate: 0, scale: 1 },
    exit: { opacity: 0, rotate: 90, scale: 0.8 },
    transition: { duration: 0.4, ease: "easeOut" }
  },
  style: {
    initial: { ...style1 },
    animate: { ...style2 },
    exit: { ...style1 },
    transition: { duration: 0.4, ease: "easeInOut" }
  }
});

export const FadingValue = ({ value, fadeType = "fade", style1, style2 }) => {

  const { initial, animate, exit, transition } = fadeTypes(style1, style2)[fadeType] || fadeTypes(style1, style2).fade;

  return (
    <div style={{ position: "relative", minHeight: "1em" }}>
      <AnimatePresence mode="wait">
        <motion.span
          key={value}
          initial={initial}
          animate={animate}
          exit={exit}
          transition={transition}
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </div>
  );
};

export const FadingElement = ({
  element,
  fadeType = "fade",
  style1,
  style2,
}) => {
  const fadeTypes = (style1, style2) => ({
    fade: {
      initial: { opacity: 0, ...style1 },
      animate: { opacity: 1, ...style2 },
      exit: { opacity: 0 },
      transition: { duration: 0.3 },
    },
    slide: {
      initial: { opacity: 0, y: 10, ...style1 },
      animate: { opacity: 1, y: 0, ...style2 },
      exit: { opacity: 0, y: -10 },
      transition: { duration: 0.3 },
    },
  });

  const { initial, animate, exit, transition } =
    fadeTypes(style1, style2)[fadeType] || fadeTypes(style1, style2).fade;

  // Create a stable key for the element
  const elementKey =
    element?.key ||
    JSON.stringify(element?.props || {}) ||
    Math.random().toString(36);

  return (
    // <div style={{ position: "relative" }}>
    <AnimatePresence mode="wait">
      <motion.div
        key={elementKey}
        initial={initial}
        animate={animate}
        exit={exit}
        transition={transition}
        style={{ display: "inline-block", width: "100%" }}
      // style={{ position: "absolute", width: "100%" }}
      >
        {element}
      </motion.div>
    </AnimatePresence>
    // </div>
  );
};


const MotionWrapper = ({ wrapperKey, cn, children, oc, ocOpts }) => {
  const fadeTypes = () => ({
    fade: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 0.1 },
    },
  });
  const { initial, animate, exit, transition } = fadeTypes().fade;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={wrapperKey} // important for diffing
        className={cn}
        onClick={() => oc?.(ocOpts)}
        initial={initial}
        animate={animate}
        exit={exit}
        transition={transition}
        layout // enables reordering animation
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export const MotionWrapperSimple = ({ children, isActive }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: isActive ? 1 : 0 }}
      transition={{ duration: 0.1, ease: 'easeOut' }}
      style={{ height: '100%' }}
    >
      {children}
    </motion.div>
  );
}


export default MotionWrapper;
